<template>
  <div>
    <v-card-text>
      <v-row>
        <v-col md="6">
          <v-subheader style="top: 20px; position: relative;">{{ caption }}</v-subheader>
        </v-col>
        <v-col md="6" class="px-4">
          <v-row>
            <v-col md="4">
              <v-text-field
                :value="values[0]"
                class="mt-0 pt-0 range-slider"
                hide-details
                single-line
                type="number"
                style="width: 60px;top: 10px;position: relative;"
                :min="min"
                :max='Number(values[1])-1'
                @change="$set(values, 0, $event)"
              ></v-text-field>
            </v-col>
            <v-col md="4" class="px-4">
              <v-text-field
                :value="values[1]"
                class="mt-0 pt-0 range-slider"
                hide-details
                single-line
                type="number"
                style="width: 60px;top: 10px;position: relative;"
                :min="Number(values[0])+1"
                :max='max'
                @change="$set(values, 1, $event)"
              ></v-text-field>
            </v-col>
            <v-col md="4" class="px-4">
              <v-checkbox
                v-model="values[2]"
                label="Включено"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: "RangeSlider",
  props: {
    value: { type: Array, dafault: [3, 20], required: true },
    caption: { type: String, default: "Область от и до" },
    min: { type: Number, default: 1 },
    max: { type: Number, default: 50 },
  },
  computed: {
    values: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style lang='sass' scoped>
.range-slider
  width: 100px !important

</style>
